export default __webpack_public_path__ + "static/media/aweth.b0f058ad.svg";